const API_HOST = import.meta.env.VITE_API_HOST;

export const request = async (
  url: string,
  method: 'GET' | 'POST' | 'PATCH' | 'PUT' | 'DELETE',
  data: unknown,
  headers: Headers = new Headers(),
  fetchParams: RequestInit = {},
  apiVersion: 'v1' | 'v2' = 'v1',
  customBaseUrl?: string,
): Promise<Response> => {
  const common = {
    method,
    ...fetchParams,
  };

  if (!headers.has('Accept')) {
    headers.set('Accept', 'application/json');
  }

  let body: Nullable<BodyInit> = undefined;

  if (data !== null) {
    if (data instanceof FormData) {
      body = data;
    } else {
      body = JSON.stringify(data);
      headers.set('Content-Type', 'application/json');
    }
  }

  const targetHost = customBaseUrl || API_HOST;
  const isAbsoluteUrl = /^https?:\/\//i.test(url);
  const finalUrl = isAbsoluteUrl ? url : `${targetHost}/${apiVersion}${url}`;

  return fetch(finalUrl, {
    ...common,
    body,
    headers,
  });
};
